module.exports = __webpack_public_path__ + "static/media/scrubblitz-4.ac1d8a86.jpg";